import { Agent } from '@/types/AgentType';
import { Contract } from '@/types/ContractType';
import { SubmitAllProposalsPayload } from '@/types/NegotiationType';
import { Product } from '@/types/ProductType';
import { rtkApi } from '../rtkApi';

export const PropertyById = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgent: builder.query<Product, string>({
      query: (propertyId) => ({ url: `/agent/${propertyId}` }),
      providesTags: (_response, _result, propertyId) => [
        { type: 'Property', id: propertyId },
      ],
    }),
    addContractByID: builder.mutation<
      Contract,
      { agentId: string; contractId: string }
    >({
      query: ({ agentId, contractId }) => ({
        url: `/agent/add-property/${agentId}`,
        method: 'POST',
        data: { contractId },
      }),
      invalidatesTags: (_response, _result, { contractId }) => [
        { type: 'Property', id: contractId },
      ],
    }),
    getContractByID: builder.query<Contract, string>({
      query: (contractId) => ({ url: `/contract/agent/${contractId}` }),
      providesTags: (_response, _result, contractId) => [
        { type: 'Contract', id: contractId },
      ],
    }),
    getAgentContractByID: builder.query<Contract[], string>({
      query: (agentId) => ({ url: `/agent/property/${agentId}` }),
      providesTags: (_response, _result, agentId) => [
        { type: 'Contract', id: agentId },
      ],
    }),
    getAllContracts: builder.query<Contract[], string>({
      query: (agentId) => ({ url: `/contract/agent/all/${agentId}` }),
      providesTags: (_response, _result, agentId) => [
        { type: 'Contract', id: agentId },
      ],
    }),
  }),
});

export const {
  useGetAgentQuery,
  useAddContractByIDMutation,
  useGetContractByIDQuery,
  useGetAgentContractByIDQuery,
  useGetAllContractsQuery,
} = PropertyById;
